import {connect} from 'react-redux';
import ListContainer from './ListContainer';
import {AppName, PagedListState} from '../Redux/Types';
import {deleteAction, fetchListAction} from '../Redux/Actions';

export type StoreState = { appNames: PagedListState<AppName>; };

export const mapState = (state: StoreState): PagedListState<AppName> => {
    return {
        rows: state.appNames.rows,
        total: state.appNames.total,
        offset: state.appNames.offset,
        limit: state.appNames.limit,
        isLoading: state.appNames.isLoading,
    };
};

export const mapDispatch = {
    fetchList: fetchListAction,
    deleteRow: deleteAction,
};

export default connect(mapState, mapDispatch as any)(ListContainer);
